import { UseFormSetError } from 'react-hook-form'

export const passwordValidator = () => {
  const checkIfHasSequence = (value: string): boolean => {
    for (let i = 0; i < value.length; i++) {
      for (let j = i + 1; j < value.length; j++) {
        if (value[i] == value[j]) {
          if (j + 1 >= value.length) {
            continue
          }
          if (value[i] == value[j + 1]) {
            return true
          }
        }
      }
    }
    return false
  }

  const isPasswordModelValid = <T>(
    campoSenha: string,
    nomeCampo: any,
    setErrorMessage?: UseFormSetError<T>
  ): boolean => {
    if ((campoSenha.match(/[0-9]/g)?.length ?? 0) < 2) {
      if (setErrorMessage) {
        setErrorMessage(nomeCampo, {
          message: 'Senha deve ter no minimo 2 números'
        })
      }
      return false
    }

    if ((campoSenha.match(/[a-z]/g)?.length ?? 0) < 1) {
      if (setErrorMessage) {
        setErrorMessage(nomeCampo, {
          message: 'Senha deve ter no mínimo um caractere em caixa baixa'
        })
      }
      return false
    }

    if ((campoSenha.match(/[A-Z]/g)?.length ?? 0) < 1) {
      if (setErrorMessage) {
        setErrorMessage(nomeCampo, {
          message: 'Senha deve ter no mínimo um caractere em caixa alta'
        })
      }
      return false
    }

    if ((campoSenha.match(/[a-zA-Z]/g)?.length ?? 0) < 2) {
      if (setErrorMessage) {
        setErrorMessage(nomeCampo, {
          message: 'Senha deve ter no minimo 2 caracteres'
        })
      }
      return false
    }

    if (checkIfHasSequence(campoSenha)) {
      if (setErrorMessage) {
        setErrorMessage(nomeCampo, {
          message: 'Não deve haver sequências de caracteres'
        })
      }
      return false
    }

    if (
      (campoSenha?.replace(' ', '')?.length ?? 0) != (campoSenha?.length ?? 0)
    ) {
      if (setErrorMessage) {
        setErrorMessage(nomeCampo, {
          message: 'Senha não deve conter espaços em branco'
        })
      }
      return false
    }

    return true
  }

  return { isPasswordModelValid }
}
